

















































































































// tslint:disable-next-line
import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';

const cssPrefix2 = 'operator_wrapper';
const storeName = 'ConnectWiseManageStoreModule';
const profileStoreName = 'SnbProfileStoreModule';

@Component({
  components: {
    SwButton,
    SwTextfield,
    SwIcon,
    SwCheckbox,
  },
})
export default class UserOperatorsMapping extends SwExtendedVue {
  cssPrefix2 = cssPrefix2;

  empSearched: string = '';
  oprSearched: string = '';
  selectedEmployees: any = [];
  employees: any = [];
  tempEmployees: any = [];
  filteredSearchEmpList = this.employees;
  selectedEmpFlag: boolean | 'semi' = false;
  selectedOperators: any = [];
  operators: any = [];
  tempOperators: any = [];
  selectedOprFlag: boolean | 'semi' = false;

  get serverDetailsFromStore() {
    return { ...this.$store.getters[`${storeName}/getCwServerDetails`] };
  }

  get operator() {
    return this.operators;
  }

  get employeeList() {
    return this.$store.getters[`${storeName}/getEmployees`];
  }

  updateServerDetails(key: any, event: any) {
    this.$store.commit(`${storeName}/updateCwServerDetails`, { key, value: event });
  }

  updateEmployeeList(emp: any) {
    this.$store.commit(`${storeName}/updateEmployees`, emp);
  }

  onEmployeeSelect() {
    if (this.selectedEmployees.length === this.employees.length) {
      this.selectedEmpFlag = true;
    } else if (this.selectedEmployees.length > 0) {
      this.selectedEmpFlag = 'semi';
    } else {
      this.selectedEmpFlag = false;
    }
  }

  onAllEmployeeSelect(value: any) {
    if (value === true) {
      this.selectedEmpFlag = true;
      this.employees.map((emp: any) => this.selectedEmployees.push(emp.userName));
    } else {
      this.selectedEmpFlag = false;
      this.selectedEmployees = [];
    }
  }

  onOperatorSelect() {
    if (this.selectedOperators.length === this.operators.length) {
      this.selectedOprFlag = true;
    } else if (this.selectedOperators.length > 0) {
      this.selectedOprFlag = 'semi';
    } else {
      this.selectedOprFlag = false;
    }
  }

  onAllOperatorSelect(value: any) {
    if (value === true) {
      this.selectedOprFlag = true;
      this.operators.map((emp: any) => this.selectedOperators.push(emp.userName));
    } else {
      this.selectedOprFlag = false;
      this.selectedOperators = [];
    }
  }

  addUsersToOperators() {
    if (this.selectedEmployees.length > 0) {
      let emplList = this.employees;
      let operatorList = this.operators;
      // eslint-disable-next-line array-callback-return
      emplList.map((emp: any) => this.selectedEmployees.map((se: any) => {
        if (se === emp.userName) operatorList.push(emp);
      }));
      if (this.selectedEmployees.length === emplList.length) {
        emplList = [];
      } else {
        emplList = emplList.filter((emp: any) => !this.selectedEmployees.some((semp: any) => semp === emp.userName));
      }
      this.selectedEmployees = [];
      this.selectedEmpFlag = false;
      const dataObject: any = {};
      operatorList.forEach((datum: any) => {
        if (!Object.hasOwnProperty(datum.userName)) {
          dataObject[datum.userName] = datum;
        }
      });
      operatorList = Object.values(dataObject);
      this.updateEmployeeList(emplList);
      this.updateServerDetails('userList', operatorList);
      this.employees = JSON.parse(JSON.stringify(this.employeeList));
      this.operators = JSON.parse(JSON.stringify(this.serverDetailsFromStore.userList));
      this.tempEmployees = this.employees;
      this.tempOperators = this.operators;
    } else {
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: this.$t('psaIntegration.noUsersSelected')
        .toString(),
      });
    }
  }

  removeUsersFromOperators() {
    if (this.selectedOperators.length > 0) {
      let emplList = this.employees;
      let operatorList = this.operators;
      // eslint-disable-next-line array-callback-return
      operatorList.map((opr: any) => this.selectedOperators.map((so: any) => {
        if (so === opr.userName) { emplList.push(opr); }
      }));
      if (this.selectedOperators.length === operatorList.length) {
        operatorList = [];
      } else {
        operatorList = operatorList.filter((opr: any) => !this.selectedOperators.some((sopr: any) => sopr === opr.userName));
      }
      this.selectedOperators = [];
      this.selectedOprFlag = false;
      const dataObject: any = {};
      emplList.forEach((datum: any) => {
        if (!Object.hasOwnProperty(datum.userName)) {
          dataObject[datum.userName] = datum;
        }
      });
      emplList = Object.values(dataObject);
      this.updateEmployeeList(emplList);
      this.updateServerDetails('userList', operatorList);
      this.employees = JSON.parse(JSON.stringify(this.employeeList));
      this.operators = JSON.parse(JSON.stringify(this.serverDetailsFromStore.userList));
      this.tempEmployees = this.employees;
      this.tempOperators = this.operators;
    } else {
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: this.$t('psaIntegration.noOpertatorSelected')
        .toString(),
      });
      // this.renderErrorMessage('No operators selected.');
    }
  }

  onSerachEmployee(value: string) {
    if (value === '') {
      this.employees = this.tempEmployees;
    } else if (value !== '' && this.employees.some((emp: any) => emp.userName.includes(value) || emp.fullName.includes(value))) {
      this.employees = this.employees.filter((emp: any) => emp.userName.includes(value) || emp.fullName.includes(value));
    } else {
      this.employees = this.tempEmployees;
    }
  }

  onSerachOperator(value: string) {
    if (value === '') {
      this.operators = this.tempOperators;
    } else if (value !== '' && this.operators.some((opr: any) => opr.userName.includes(value) || opr.fullName.includes(value))) {
      this.operators = this.operators.filter((opr: any) => opr.userName.includes(value) || opr.fullName.includes(value));
    } else {
      this.operators = this.tempOperators;
    }
  }

  async usersList() {
    console.warn('userlist api called');
    this.$store.dispatch(`${profileStoreName}/getUserList`, 'NO')
    .then((resp: any) => {
      if (resp.operationStatus === 'OK' && resp.content) {
        console.warn(resp);
        if (resp.content.userList && resp.content.userList.length !== 0) {
          let userList = resp.content.userList;
          console.warn(userList);
          userList = userList.filter((us: any) => us.employee === 'YES');
          let allEmployees = userList.map((usr: any) => { return { userName: usr.emailAddress, fullName: usr.fullName }; });
          if (typeof this.serverDetailsFromStore.userList === 'string') {
            const tempList = this.convertStringToArrayOfObjects(this.serverDetailsFromStore.userList);
            this.serverDetailsFromStore.userList = tempList;
          }
          const usersAsOperators = JSON.parse(JSON.stringify(this.serverDetailsFromStore.userList));
          allEmployees = allEmployees.filter((emp: any) => !usersAsOperators?.some((em: any) => emp.userName === em.userName));
          this.updateEmployeeList(allEmployees);
          this.employees = JSON.parse(JSON.stringify(this.employeeList));
          this.operators = usersAsOperators || [];
          this.tempEmployees = this.employees;
          this.tempOperators = this.operators;
          console.warn(this.employees);
          console.warn(this.operators);
        }
      } else {
        this.$store.commit('enqueueMessage', {
          infoType: 'failed',
          infoMsg: resp.msgDesc || this.$t('systemMessages.wrong')
          .toString(),
        });
      }
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  convertStringToArrayOfObjects(list: any) {
    let data = list.replace(/[[\]]/g, '');
    data = data.split(', {');
    const tempData: any[] = [];
    data.forEach((item: any, index: number) => {
      let currItem = item.replace(/'/g, '"');
      if (index > 0) {
        currItem = `{${currItem}`;
      }
      tempData.push(JSON.parse(currItem));
    });
    return tempData;
  }

  async created() {
    console.warn('inside user operator mapping component');
    await this.usersList();
  }

}
